import {
  ShellIconActivity,
  ShellIconArchive,
  ShellIconBarChart,
  ShellIconBuilding,
  ShellIconClipboardList,
  ShellIconDollarSign,
  ShellIconLayers,
  ShellIconLayout,
  ShellIconLock,
  ShellIconPackage,
  ShellIconReceipt,
  ShellIconRuler,
  ShellIconSettings,
  ShellIconSparkles,
  ShellIconTag,
  ShellIconUser,
  ShellIconUsers,
  ShellIconWrench,
} from '@zrsystem/ui';

import { appPaths } from '@/app/router/paths.js';
import type { ShellNavEntry } from '@/shared/shell/nav.types.js';

/** Stub MVP — nível `tenant`. */
export const TENANT_NAV_ENTRIES: readonly ShellNavEntry[] = [
  {
    kind: 'link',
    id: 'org-home',
    label: 'Painel consolidado',
    icon: ShellIconBarChart,
    path: appPaths.org,
    matchPrefix: appPaths.org,
    enabled: true,
  },
  {
    kind: 'link',
    id: 'org-customers',
    label: 'Clientes',
    icon: ShellIconUsers,
    path: appPaths.organizationCustomers,
    matchPrefix: appPaths.organizationCustomers,
    enabled: true,
  },
  {
    kind: 'group',
    id: 'org-catalog',
    label: 'Catálogo',
    icon: ShellIconPackage,
    matchPrefix: '/organizacao/catalogo',
    defaultPath: appPaths.organizationServices,
    children: [
      {
        kind: 'route',
        id: 'org-catalog-services',
        label: 'Serviços',
        icon: ShellIconWrench,
        path: appPaths.organizationServices,
        matchPrefix: appPaths.organizationServices,
      },
      {
        kind: 'route',
        id: 'org-catalog-products',
        label: 'Produtos',
        icon: ShellIconArchive,
        path: appPaths.organizationProducts,
        matchPrefix: appPaths.organizationProducts,
      },
      {
        kind: 'route',
        id: 'org-catalog-useful-life',
        label: 'Vida útil',
        icon: ShellIconActivity,
        path: appPaths.organizationUsefulLife,
        matchPrefix: appPaths.organizationUsefulLife,
      },
      {
        kind: 'route',
        id: 'org-catalog-revision-plans',
        label: 'Planos de revisão',
        icon: ShellIconClipboardList,
        path: appPaths.organizationRevisionPlans,
        matchPrefix: appPaths.organizationRevisionPlans,
      },
      {
        kind: 'route',
        id: 'org-catalog-maintenance-checklists',
        label: 'Check-lists de manutenção',
        icon: ShellIconClipboardList,
        path: appPaths.organizationMaintenanceChecklists,
        matchPrefix: appPaths.organizationMaintenanceChecklists,
      },
      {
        kind: 'route',
        id: 'org-catalog-price-policy',
        label: 'Precificação',
        icon: ShellIconDollarSign,
        path: appPaths.organizationPricePolicy,
        matchPrefix: appPaths.organizationPricePolicy,
      },
      {
        kind: 'route',
        id: 'org-catalog-price-simulator',
        label: 'Simulador',
        icon: ShellIconBarChart,
        path: appPaths.organizationPriceSimulator,
        matchPrefix: appPaths.organizationPriceSimulator,
      },
      {
        kind: 'route',
        id: 'org-catalog-price-promotions',
        label: 'Promoções',
        icon: ShellIconSparkles,
        path: appPaths.organizationPricePromotions,
        matchPrefix: appPaths.organizationPricePromotions,
      },
      {
        kind: 'quickPanel',
        id: 'org-catalog-categories',
        label: 'Categorias',
        icon: ShellIconLayers,
        panelKey: 'catalog-taxonomy-list',
        entity: 'categories',
        title: 'Categorias',
      },
      {
        kind: 'quickPanel',
        id: 'org-catalog-brands',
        label: 'Marcas',
        icon: ShellIconTag,
        panelKey: 'catalog-taxonomy-list',
        entity: 'brands',
        title: 'Marcas',
      },
      {
        kind: 'quickPanel',
        id: 'org-catalog-product-types',
        label: 'Tipos de produto',
        icon: ShellIconLayout,
        panelKey: 'catalog-taxonomy-list',
        entity: 'product-types',
        title: 'Tipos de produto',
      },
      {
        kind: 'quickPanel',
        id: 'org-catalog-service-types',
        label: 'Tipos de serviço',
        icon: ShellIconWrench,
        panelKey: 'catalog-taxonomy-list',
        entity: 'service-types',
        title: 'Tipos de serviço',
      },
      {
        kind: 'quickPanel',
        id: 'org-catalog-manufacturers',
        label: 'Fabricantes',
        icon: ShellIconBuilding,
        panelKey: 'catalog-taxonomy-list',
        entity: 'manufacturers',
        title: 'Fabricantes',
      },
      {
        kind: 'quickPanel',
        id: 'org-catalog-measurement-units',
        label: 'Unidades de medida',
        icon: ShellIconRuler,
        panelKey: 'catalog-taxonomy-list',
        entity: 'measurement-units',
        title: 'Unidades de medida',
      },
    ],
  },
  {
    kind: 'group',
    id: 'financeiro',
    label: 'Financeiro',
    icon: ShellIconDollarSign,
    matchPrefix: '/financeiro',
    defaultPath: appPaths.financeAccountsReceivable,
    children: [
      {
        kind: 'route',
        id: 'finance-accounts-receivable',
        label: 'Contas a receber',
        icon: ShellIconReceipt,
        path: appPaths.financeAccountsReceivable,
        matchPrefix: appPaths.financeAccountsReceivable,
      },
      {
        kind: 'route',
        id: 'finance-accounts-payable',
        label: 'Contas a pagar',
        icon: ShellIconDollarSign,
        path: appPaths.financeAccountsPayable,
        matchPrefix: appPaths.financeAccountsPayable,
      },
      {
        kind: 'route',
        id: 'finance-cash-flow',
        label: 'Fluxo de caixa',
        icon: ShellIconBarChart,
        path: appPaths.financeCashFlow,
        matchPrefix: appPaths.financeCashFlow,
      },
      {
        kind: 'route',
        id: 'finance-income-statement',
        label: 'DRE',
        icon: ShellIconBarChart,
        path: appPaths.financeIncomeStatement,
        matchPrefix: appPaths.financeIncomeStatement,
      },
      {
        kind: 'route',
        id: 'finance-chart-of-accounts',
        label: 'Plano de contas',
        icon: ShellIconLayers,
        path: appPaths.financeChartOfAccounts,
        matchPrefix: appPaths.financeChartOfAccounts,
      },
      {
        kind: 'route',
        id: 'finance-inbound-charge-policy',
        label: 'Encargos de entrada',
        icon: ShellIconLayers,
        path: appPaths.financeInboundChargePolicy,
        matchPrefix: appPaths.financeInboundChargePolicy,
      },
    ],
  },
  {
    kind: 'group',
    id: 'fiscal',
    label: 'Fiscal',
    icon: ShellIconReceipt,
    matchPrefix: '/fiscal',
    defaultPath: appPaths.fiscalDocumentos,
    children: [
      {
        kind: 'route',
        id: 'fiscal-documents',
        label: 'Documentos fiscais',
        icon: ShellIconReceipt,
        path: appPaths.fiscalDocumentos,
        matchPrefix: appPaths.fiscalDocumentos,
      },
      {
        kind: 'route',
        id: 'fiscal-dfe-inbox',
        label: 'Caixa de entrada',
        icon: ShellIconReceipt,
        path: appPaths.fiscalDfeInbox,
        matchPrefix: appPaths.fiscalDfeInbox,
        enabled: true,
      },
      {
        kind: 'route',
        id: 'fiscal-apuracao',
        label: 'Apuração',
        icon: ShellIconBarChart,
        path: appPaths.fiscalApuracao,
        matchPrefix: appPaths.fiscalApuracao,
        enabled: false,
      },
      {
        kind: 'route',
        id: 'fiscal-ncm',
        label: 'NCMs',
        icon: ShellIconTag,
        path: appPaths.fiscalNcm,
        matchPrefix: appPaths.fiscalNcm,
        enabled: true,
      },
      {
        kind: 'route',
        id: 'fiscal-parametrizacao',
        label: 'Parametrização',
        icon: ShellIconSettings,
        path: appPaths.fiscalParametrizacao,
        matchPrefix: appPaths.fiscalParametrizacao,
      },
    ],
  },
  {
    kind: 'link',
    id: 'org-places',
    label: 'Oficinas',
    icon: ShellIconWrench,
    path: appPaths.organizationWorkshops,
    matchPrefix: appPaths.organizationWorkshops,
    enabled: true,
  },
  {
    kind: 'group',
    id: 'org-access',
    label: 'Acessos',
    icon: ShellIconLock,
    matchPrefix: appPaths.organizationUsers,
    defaultPath: appPaths.organizationUsers,
    children: [
      {
        kind: 'route',
        id: 'org-users',
        label: 'Usuários',
        icon: ShellIconUsers,
        path: appPaths.organizationUsers,
        matchPrefix: appPaths.organizationUsers,
      },
      {
        kind: 'route',
        id: 'org-profiles',
        label: 'Perfis',
        icon: ShellIconUser,
        path: appPaths.organizationProfiles,
        matchPrefix: appPaths.organizationProfiles,
      },
    ],
  },
  {
    kind: 'link',
    id: 'org-settings',
    label: 'Organização',
    icon: ShellIconBuilding,
    path: appPaths.organizationSettings,
    matchPrefix: appPaths.organizationSettings,
    enabled: true,
  },
] as const;
